export const EVENT="/tv/get-events";
export const HALL_OCCUPANCY ="/tv/get-activities";
export const SEND_NUMBER="/evaluations";
export const SERVICES_QUEUE="/queue/services"
export const PROCEDUR_QUEUE="/queue/procedures"
export const QUEUE="/queue/visitors"
export const QUEUE_TV=`/tv/get-waiting`